import { useState, useCallback } from 'react';

/**
 * Custom hook for pagination logic
 * Provides state and handlers for paginated lists
 */
export const usePagination = (initialPage = 1) => {
  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);

  const goToPage = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const nextPage = useCallback(() => {
    setPage((prev) => Math.min(prev + 1, totalPages));
  }, [totalPages]);

  const previousPage = useCallback(() => {
    setPage((prev) => Math.max(prev - 1, 1));
  }, []);

  const resetPage = useCallback(() => {
    setPage(1);
  }, []);

  return {
    page,
    totalPages,
    setTotalPages,
    goToPage,
    nextPage,
    previousPage,
    resetPage,
    isFirstPage: page === 1,
    isLastPage: page === totalPages,
    hasMultiplePages: totalPages > 1,
  };
};
